<template>
    <div class="top uk-margin-bottom">
        <div class="uk-overlay-panel" style="z-index:500;position:fixed;" @click="slideNav(0)" :class="is_index == 0 ? 'uk-hidden' : ''" ></div>
  		<nav class="uk-navbar uk-text-center top_nav" style="z-index:559;position:relative;" v-if="currentMerchant">
			<a href="#offcanvas" class="uk-navbar-toggle ipp-text-white uk-visible-small" data-uk-offcanvas=""></a>   
	       	<router-link class="uk-hidden-small" :to="userInfo.is_bind_secret == 1 ?'/index' : ''">
	        	<!-- <img  class="uk-navbar-brand" style="margin-top:2px; height:35px;" src="/static/imgs/logo.png">	 -->
	        	<img  class="uk-navbar-brand" style="margin-top:2px; height:35px;" :src="plat_white_logo">	
	        </router-link>

	        <a v-if="currentMerchantNo && userInfo.is_bind_secret == 1" class="merchant_name uk-float-left" @click="getDefaultMerchant">
	        	<span class="uk-icon-circle uk-float-left" :class="'ipp-text-status-'+currentMerchant.merchant_status"></span>
	        	<span class=" uk-hidden-small  uk-float-left ipp-text-white">{{subStrText(currentMerchant.merchant_entity_name,20)}} </span>
	        	<span class=" uk-visible-small  uk-float-left ipp-text-white">{{subStrText(currentMerchant.merchant_entity_name,10)}} </span>
	        </a>	

	        <div class="uk-float-right uk-margin-small-right" v-if="userInfo">
	            <ul class="uk-navbar-nav">				
					<li class="uk-parent"  @click="slideNav(1)" :class="is_index == 1 ? 'uk-open' : '' " >						
						<a class="uk-hidden-small" v-if="userInfo.user_nickname">
							<i class="ipp-icon ipp-icon-user"></i> {{ $t('common.hello') }} {{ userInfo.user_nickname}} <i class="uk-icon-caret-down"></i>
						</a>				
						<a class="uk-visible-small"  v-if="userInfo.user_nickname">
							 <i class="ipp-icon ipp-icon-user"></i> {{subStrText(userInfo.user_nickname,5) }} <i class="uk-icon-caret-down"></i>
						</a>
						<div class="uk-dropdown uk-dropdown-small uk-dropdown-bottom" style="right:0;">
							<ul class="uk-nav uk-nav-navbar">
								<li @click="slideNav(0)"><router-link to="/Setting/set"><span class="uk-icon-cog"></span>{{ $t('menu.seeting')}} </router-link></li>
								<li><a @click="logout"><span class="uk-icon-power-off"></span>{{ $t('menu.logout')}}</a></li>
							</ul>
						</div>
					</li>
				</ul>
	        </div>	    
	    </nav>

        <div class="uk-overlay-panel uk-flex uk-flex-center uk-flex-middle uk-overlay-panel-loading" v-if="isload == 1"> 
	      <div class="loading">
	        <div class="load"><span class="uk-icon-spinner uk-icon-spin"></span></div>
	      </div>
	    </div> 
    </div>
</template>
<script>
import global_ from './resouces/config'//引用模块进来
import system from '@/components/common/resouces/system'

export default {
    name: 'top',
    data(){
    	return {    		  		
    		currname:'',
            is_index:0,
		}    
    },    
	computed:{
		domain(){
			return this.$store.state.home.domain;
		},
		publicdomain(){
				return this.$store.state.home.publicdomain;
		},
		userInfo(){
			return this.$store.state.home.userInfo;
		},
		merchant_list(){
      		return this.$store.state.home.merchant_list;
    	},
		currentMerchantNo(){
			return this.$store.state.home.current_merchant_no; 
		},
		currentMerchant(){
				return this.$store.state.home.current_merchant; 
		},
		merchantCount(){
			return this.$store.state.home.merchantCount
		},
		
		isload(){
			return this.$store.state.home.isload
		},
		plat_white_logo(){
			return this.$store.state.home.plat_white_logo;
		}
	},  

	created() { 

	},
	mounted: function() {	  
        // this.slideNav(0);
	},

	activated:function(){
        // this.slideNav(0);  

    	if(this.$route.meta.keepAlive){
			$('html').removeClass('uk-modal-page');
			$('body').removeClass('uk-offcanvas-page'); 
			$('body').attr('style',''); 
			$('#offcanvas').removeClass('uk-active');
			this.backTop();                        
    	}
  	},
    methods:{

        getDefaultMerchant(){       
        if(this.currentMerchant.merchant_status == 1 || this.currentMerchant.merchant_status == 2){
            this.$router.push({
              path:'/Merchant/merchant',
              query:{
                merchant_no:this.currentMerchant.merchant_no
              }
            })
        }else{
            this.$router.push({
              path:'/Merchant/merchant_info',
              query:{
                merchant_no:this.currentMerchant.merchant_no
              }
            })
        }       
      },
		logout(){
			 this.$store.dispatch('logOut');
		},		
        setWebTitle(name,v){
             document.title = name +'/' + v     
        },
        subStrText(v,n){            
          let val = this.common.subStrLangText(v,n);
          return val
        },
        setWebIcon(icon){
        	var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
		    link.type = 'image/x-icon';
		    link.rel = 'shortcut icon';
		    link.href = icon
		    document.getElementsByTagName('head')[0].appendChild(link);
        },
        backTop() {
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        },
        slideNav(v){
                       
        	this.$nextTick(() => {		        
        		console.log(v)
       			this.is_index = v
	      	});

        }
    }
}
</script>

<style scoped lang="scss">
.uk-overlay-panel-loading{position:fixed;z-index: 99999999999; background:#fff; }
.loading{ width:120px; height:120px; line-height:120px; color:#fff; background:rgba(0,0,0,.8); font-size:30px; border-radius:10px; text-align:center; position:relative;}
.loading p{ position:absolute; left:0;bottom:0;right:0; color:#fff; line-height:60px;}
</style>



// WEBPACK FOOTER //
// src/components/common/top.vue